const a = 32;
var s = /* @__PURE__ */ ((e) => (e.Homepage = "homepage", e.Locations = "locations", e.Messages = "messages", e.Reviews = "reviews", e.Analytics = "analytics", e.Settings = "settings", e.Posts = "posts", e.Search = "search", e.More = "more", e))(s || {});
export {
  a as DEFAULT_PRODUCT_ICON_SIZE_V2,
  s as ProductIconsAppV2Enum
};
